import { render, staticRenderFns } from "./CatalogItems.vue?vue&type=template&id=2a54aa7c"
import script from "./CatalogItems.vue?vue&type=script&lang=js"
export * from "./CatalogItems.vue?vue&type=script&lang=js"
import style0 from "./CatalogItems.vue?vue&type=style&index=0&id=2a54aa7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports